/**
 * Calendar Configuration Constants
 * Centralized constants for calendar-related magic numbers and strings
 */

export const CALENDAR_CONFIG = {
    // Year ranges for event generation
    BIRTHDAY_FUTURE_YEARS: 5,
    ANNIVERSARY_FUTURE_YEARS: 50,
    BIRTHDAY_MAX_AGE: 100, // Maximum age to generate birthdays for
    
    // Date formats
    DATE_FORMAT: 'YYYY-MM-DD',
    TIME_FORMAT: 'hh:mm A',
    
    // UI Colors
    UI_COLORS: {
        // Border colors
        BORDER_LIGHT: '#e0e0e0',
        
        // Background colors
        BG_LIGHT: '#f9f9f9',
        BG_WHITE: '#fff',
        BG_ACTIVE: '#6b7280',
        BG_HOLIDAY: '#FFCCCC',
        BG_LOADING: '#f9fafb',
        
        // Text colors
        TEXT_PRIMARY: '#333',
        TEXT_SECONDARY: '#666',
        TEXT_ACTIVE: '#fff',
    },
};

